namespace AgerLMS.LMS {
    export interface LessonRow {
        Id?: number;
        LessonName?: string;
        LessonDescription?: string;
        CourseId?: number;
        SectionId?: number;
        LessonType?: LessonTypes;
        LessonFileType?: LessonFileTypes;
        OriginalFileStreamUrl?: string;
        OriginalFileUploadUrl?: string;
        VideoSecondVersionUrl?: string;
        Seo?: string;
        DisplayOrder?: number;
        DripContent?: boolean;
        Downloadable?: boolean;
        Accessibility?: LessonAccessibility;
        Volume?: number;
        TotalSecondsMasked?: string;
        TotalSeconds?: number;
        IsUserCompleted?: boolean;
        CourseCourseName?: string;
        CourseCourseDescription?: string;
        CourseCategoryId?: number;
        CoursePrice?: number;
        CourseSalePrice?: number;
        SectionSectionName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace LessonRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'LessonName';
        export const localTextPrefix = 'LMS.Lesson';
        export const lookupKey = 'LMS.Lesson';

        export function getLookup(): Q.Lookup<LessonRow> {
            return Q.getLookup<LessonRow>('LMS.Lesson');
        }
        export const deletePermission = 'LMS';
        export const insertPermission = 'LMS';
        export const readPermission = 'LMS';
        export const updatePermission = 'LMS';

        export declare const enum Fields {
            Id = "Id",
            LessonName = "LessonName",
            LessonDescription = "LessonDescription",
            CourseId = "CourseId",
            SectionId = "SectionId",
            LessonType = "LessonType",
            LessonFileType = "LessonFileType",
            OriginalFileStreamUrl = "OriginalFileStreamUrl",
            OriginalFileUploadUrl = "OriginalFileUploadUrl",
            VideoSecondVersionUrl = "VideoSecondVersionUrl",
            Seo = "Seo",
            DisplayOrder = "DisplayOrder",
            DripContent = "DripContent",
            Downloadable = "Downloadable",
            Accessibility = "Accessibility",
            Volume = "Volume",
            TotalSecondsMasked = "TotalSecondsMasked",
            TotalSeconds = "TotalSeconds",
            IsUserCompleted = "IsUserCompleted",
            CourseCourseName = "CourseCourseName",
            CourseCourseDescription = "CourseCourseDescription",
            CourseCategoryId = "CourseCategoryId",
            CoursePrice = "CoursePrice",
            CourseSalePrice = "CourseSalePrice",
            SectionSectionName = "SectionSectionName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
